import { ICON_TYPES } from '../constants';

export const GreyRightArrow = (): JSX.Element => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.172 7.49998H13.3791L12.5256 6.64643L7.51511 1.63599L8.222 0.929092L15.2929 7.99998L8.222 15.0709L7.51511 14.364L12.5256 9.35354L13.3791 8.49998H12.172H0.5V7.49998H12.172Z"
        fill="#A39E97"
        stroke="#A39E97"
      />
    </svg>
  );
};

GreyRightArrow.iconType = ICON_TYPES.GREY_RIGHT_ARROW;
